let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../../../utils/Constants.js");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ClientCall = require("./ClientCall");
let ContactGrabber = require("./ContactGrabber");
let EditContactModal = require("./EditContactModal");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ClientPortal = require("./ClientPortal");

let Contact = dd.createClass({
  __onClick: esUtils.wrapPreventDefault(function () {
    let { setEditingId, contact } = this.props;
    setEditingId(contact.id);
  }),

  /**
   * Open an external window
   * @param opento_url
   * @param crmkind
   * @returns {*}
   * @private
   */
  __onClickExternalCRM(opento_url, crmkind) {
    return esUtils.wrapPreventDefault(function () {
      let CRMWindowName = _.get(
        Constants,
        [
          "GRAB_SERVICES_WITH_DEEP_INTEGRATION",
          crmkind.toUpperCase(),
          "browser_window_name",
        ],
        "genericcrm"
      );
      window.open(opento_url, CRMWindowName);
    });
  },

  /**
   * Given an external CRM id (like "KARMACRM:12345"), figure out if we should
   * offer a link to that contact in the external app.
   *
   * This depends on /authenticate/getdisplaylists sending over data in the perspeaker.xxx.crm_sso key
   * with a value for contact_url that looks like "https://app.hubspot.com/contacts/6224665/contact/{id}/"
   * where {id} will be replaced with the contact ID.
   *
   * @param contact
   * @param crm_sso
   * @returns {{opentocontact_url: *, crmkind: *}}
   * @private
   */
  __computeExternalCRMLink: function (contact, crm_sso) {
    //possibly link to external CRM (contact.externalid = "KARMACRM:12345", for example)
    let opentocontact_url = null;
    let crmkind = null;

    let externalid = _.get(contact, "externalid", "");
    externalid = "string" === typeof externalid ? externalid.split(":") : [];
    if (2 === externalid.length) {
      //we have an id for an external in the form of KARMACRM:123456
      crmkind = externalid[0];
      if (
        !_.isEmpty(
          _.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind])
        )
      ) {
        opentocontact_url = _.get(
          _.find(crm_sso, { kind: crmkind }),
          "contact_url"
        );
        if (!_.isEmpty(opentocontact_url)) {
          opentocontact_url = opentocontact_url.replace("{id}", externalid[1]);
        }
      }
    }
    return { opentocontact_url, crmkind };
  },

  render() {
    let { contact, event, Displaylists, from_parent } = this.props;
    let mail_to_url = Constants.generateNotemailHREF(
      event,
      contact,
      Displaylists
    );
    if (!mail_to_url) {
      mail_to_url = Constants.buildMailToURLForEvent(
        event,
        contact.email,
        Displaylists
      );
    }
    let crmlink = _.get(Displaylists, ["perspeaker"]);
    crmlink = _.find(crmlink, { sid: event.sids[0] });
    crmlink = _.get(crmlink, "crm_sso", []);
    let { opentocontact_url, crmkind } = this.__computeExternalCRMLink(
      contact,
      crmlink
    ); //trouble if multiple speakers on event, but that's rare

    //each contact row
    return dd.tr(
      { className: "clickable" },
      dd.td(
        { onClick: this.__onClick },
        from_parent
          ? dd.i({ className: "fa fa-arrow-circle-up", title: "From Parent" })
          : null,
        _.isArray(contact.groupcodes)
          ? dd.div(null, contact.groupcodes.join(", "))
          : null
      ),
      dd.td(
        { onClick: this.__onClick },
        dd.div(null, dd.strong(null, contact.cname)),
        contact.company ? dd.div(null, dd.strong(null, contact.company)) : null,
        contact.title ? dd.div(null, dd.strong(null, contact.title)) : null,
        opentocontact_url
          ? dd.a(
              {
                href: opentocontact_url,
                onClick: this.__onClickExternalCRM(opentocontact_url, crmkind),
              },
              _.get(Constants.GRAB_SERVICES, crmkind, "CRM"),
              " ",
              dd.i({
                className: "fa fa-external-link",
                style: { marginLeft: "0.25rem" },
              })
            )
          : null
      ),
      dd.td(
        { onClick: this.__onClick },
        contact.phone
          ? dd.div(
              null,
              contact.phone,
              dd.span({ className: "text-muted" }, " (phone)")
            )
          : null,
        contact.mobile
          ? dd.div(
              null,
              contact.mobile,
              dd.span({ className: "text-muted" }, " (mobile)")
            )
          : null,
        contact.fax
          ? dd.div(
              null,
              contact.fax,
              dd.span({ className: "text-muted" }, " (fax)")
            )
          : null
      ),
      dd.td(
        contact.email && mail_to_url ? null : { onClick: this.__onClick },
        contact.email
          ? dd.div(
              null,
              mail_to_url
                ? dd.a({ href: mail_to_url }, contact.email)
                : contact.email
            )
          : null
      )
    );
  },
});

let Contacts = dd.createClass({
  render() {
    let { Displaylists, event, setEditingId } = this.props;
    let contacts = event.EventContact;
    if (!_.get(event, ["flags_as_map", "marketplace", "is_set"], false)) {
      contacts = _.flattenDeep([
        _.map(event.EventContact_from_parent, function (c) {
          return _.assign({ from_parent: true }, c);
        }),
        contacts,
      ]);
    }

    if (_.size(contacts) === 0) {
      return dd.p(
        {
          className: "emptylist",
          style: {
            paddingTop: "1em",
            paddingBottom: "2em",
            paddingLeft: "1em",
          },
        },
        "Click ADD CONTACT or GRAB to add the first contact to this event."
      );
    }

    return dd.table(
      { className: "table table-hover" },
      dd.tbody(
        null,
        _.map(contacts, function (contact) {
          return Contact({
            key: contact.id,
            contact,
            setEditingId,
            event,
            Displaylists,
            from_parent: contact.from_parent,
          });
        })
      )
    );
  },
});

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return { editing_contact_id: -1, contact_from_grab: null };
  },
  Radio_setup() {
    return {
      ContactGrabber_grab_succeeded(key, contact) {
        this.setState({ editing_contact_id: 0, contact_from_grab: contact });
      },
    };
  },
  __setEditingId(id) {
    this.setState({ editing_contact_id: id, contact_from_grab: null });
  },
  __newContact: esUtils.wrapPreventDefault(function () {
    this.__setEditingId(0);
  }),
  __closeEditor: esUtils.wrapPreventDefault(function () {
    this.__setEditingId(-1);
  }),
  render() {
    let { event, Displaylists } = this.props;
    let is_limited_speaker =
      AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);

    return dd.div(
      { className: "Contacts" },
      dd.div(
        null,
        is_limited_speaker
          ? null
          : dd.span(
              { className: "pull-right", style: { marginTop: -3 } },
              dd.button(
                {
                  className: "btn btn-sm btn-default",
                  onClick: this.__newContact,
                },
                dd.i({ className: "fa fa-plus" }),
                " Add Contact"
              )
            ),
        dd.h2(null, "Contacts")
      ),
      Contacts({
        event,
        Displaylists,
        setEditingId: this.__setEditingId,
        newContact: this.__newContact,
      }),
      is_limited_speaker ? null : ContactGrabber({ event, Displaylists }),
      ClientCall({ event, Displaylists, form_section_name: "Client Call" }),
      EditContactModal({
        event,
        Displaylists,
        editing_id: this.state.editing_contact_id,
        onClose: this.__closeEditor,
        contact: this.state.contact_from_grab,
      }),
      ClientPortal({ event, form_section_name: "Client Portal", Displaylists })
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/index.js